import { isBoatEntityName } from 'minecraft-renderer/src/three/entity/boatModelRotation';
import { isRideableMinecartEntityName } from './boatRenderHints';
export function getCameraMovementMode(bot) {
    if (bot.vehicle && isRideableMinecartEntityName(bot.vehicle.name)) {
        return 'server-vehicle';
    }
    return 'local-player';
}
/** Instant camera on mount only where mineflayer snaps the seat position. */
export function shouldSnapCameraOnMount(vehicleName) {
    return isBoatEntityName(vehicleName) || isRideableMinecartEntityName(vehicleName);
}
